module.exports = __webpack_public_path__ + "img/5e3b01c.jpg";